import { MocacoAttributesPublicConstants } from '@features/products/mocaco-attributes';
import { ProductPublicModels } from '@features/products/product';

export function isPreSalePreOrderAttributeUseCase(product: ProductPublicModels.PublicProduct): boolean {
    return product.attributes.map((attribute: ProductPublicModels.PublicProductAttribute) =>
        attribute.name).includes(MocacoAttributesPublicConstants.MocacoAttributesEnum.MADEIN_PRESALEPREORDER);
}
